import User from 'data/User';
import * as React from 'react';
import { listenToPlanChange } from 'state/Store';
import styled from 'styled-components';
import { callFunction } from 'utils/FirebaseUtils';
import { hoverMixin } from 'utils/style';
import Subtitle from './components/Subtitle';
import { Order } from './Order';
import { reportBFError } from '../utils/Tracker';
import firebase from 'firebase/app';
import 'firebase/database';

const FooterView = styled.div`
  margin: 0;
  margin-top: 20px;
  font-size: 14px;
  color: rgba(var(--primary-fg-rgb), 0.7);
  line-height: 16px;

  a {
    text-decoration: none;
    ${hoverMixin('text-decoration: underline;')}
  }
`;

interface Props {
  user: User;
  order: Order;
  onCancel: () => void;
}

export const WaitForStripe: React.FC<Props> = props => {
  const { user, order, onCancel } = props;
  const didCancel = React.useRef(false);
  const [checkoutLink, setCheckoutLink] = React.useState<string | undefined>(
    undefined
  );
  const ref = React.useMemo(
    () => firebase.database().ref(`users/${user?.uid}`),
    [user]
  );
  const connection = React.useRef<any>(null);

  const disconnect = React.useCallback(() => {
    if (connection.current) {
      ref.off('value', connection.current);
      connection.current = null;
    }
  }, [connection]);

  const cancel = React.useCallback(() => {
    didCancel.current = true;
    disconnect();
    onCancel();
  }, [disconnect, onCancel]);

  const openLinkAgain = React.useCallback(() => {
    window.open(checkoutLink, '_blank');
  }, [checkoutLink]);

  React.useEffect(() => {
    // did mount
    async function onMount() {
      try {
        const result = await callFunction('createCheckoutSession', order);
        if (didCancel.current) {
          return;
        }
        const url = result.data;
        setCheckoutLink(url);
        window.open(url, '_blank');
        listenToPlanChange();
      } catch (e) {
        reportBFError(e);
        alert(e);
      }
    }
    onMount();
    return () => {
      // did unmount
      disconnect();
    };
  }, [user]);

  if (checkoutLink === undefined) {
    return (
      <div>
        <h1>Creating checkout page...</h1>
        <button
          className="large secondary"
          style={{ marginTop: 20 }}
          onClick={cancel}
        >
          Cancel
        </button>
      </div>
    );
  }

  return (
    <div>
      <h1>Continue in the other window</h1>
      <Subtitle style={{ maxWidth: 620 }}>
        A new window, or browser tab, has been opened to handle the payment.
        Please continue there.
      </Subtitle>
      <button
        className="large secondary"
        style={{ marginTop: 20 }}
        onClick={cancel}
      >
        Cancel
      </button>
      <FooterView>
        {' '}
        If the new window didn’t open,{' '}
        <a href="#" onClick={openLinkAgain}>
          click here
        </a>
        .
      </FooterView>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/buy/WaitForStripe.tsx